import React from 'react';

import {
  CheckboxInput, RelativeRow,
} from 'ui-builder';
import { useAuthorizationChecker } from 'authorization-scope';
import { TeamPermission } from 'nekst-api';
import { EventTasksToggleWrapper } from 'feature-toggle';

export type TypeFilterValue = {
  showStandardTasks: boolean,
  showEmailTasks: boolean,
  showSmsTasks: boolean,
  showKeyDatesOnly: boolean,
  showRoadmapOnly: boolean,
  showEventTasks: boolean
}

export function TypeFilterForm() {
  const { isGranted } = useAuthorizationChecker();

  return (
    <>
      <h4>OPTIONS</h4>
      <RelativeRow weights={[6, 6]}>
        <CheckboxInput source="typeFilter.showStandardTasks" />
        <EventTasksToggleWrapper>
          <CheckboxInput source="typeFilter.showEventTasks" label="Show Appointment Tasks" />
        </EventTasksToggleWrapper>
      </RelativeRow>
      <RelativeRow weights={[6, 6]}>
        <CheckboxInput source="typeFilter.showEmailTasks" label="Show Email Tasks" />
        {
          isGranted(TeamPermission.USE_SMS_TASKS_FEATURE)
            ? (
              <CheckboxInput
                source="typeFilter.showSmsTasks"
                label="Show SMS Tasks"
              />
            )
            : null
        }
      </RelativeRow>
      <RelativeRow weights={[6, 6]}>
        <CheckboxInput source="typeFilter.showKeyDatesOnly" />
        <CheckboxInput source="typeFilter.showRoadmapOnly" label="Roadmap Tasks Only" />
      </RelativeRow>
    </>
  );
}
